import { render, staticRenderFns } from "./StockInventoryInvoiceReferences.vue?vue&type=template&id=21f0b93e&scoped=true&"
import script from "./StockInventoryInvoiceReferences.vue?vue&type=script&lang=js&"
export * from "./StockInventoryInvoiceReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0b93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f0b93e')) {
      api.createRecord('21f0b93e', component.options)
    } else {
      api.reload('21f0b93e', component.options)
    }
    module.hot.accept("./StockInventoryInvoiceReferences.vue?vue&type=template&id=21f0b93e&scoped=true&", function () {
      api.rerender('21f0b93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/stock/stock-inventory/components/StockInventoryInvoiceReferences.vue"
export default component.exports